import Footer from '../components/organisms/footer'
import NavBar from '../components/organisms/navbar'
import './standardpage.css'

const StandardPage = ({ children }) => {
  return (
    <section class="standard-page">
      <NavBar />
      {children}
      <Footer />
    </section>
  )
}

export default StandardPage